import React from "react";

const WhyKeratinWhat = () => {
  return (
    <div className="blogHead-content">
      <h2>What is Keratin Hair Treatment? </h2>
      <p>
        Keratin is a type of protein that naturally occurs in hair, skin, and
        nails. It forms the building blocks of hair and is responsible for
        keeping it strong, smooth, and healthy. However, exposure to
        environmental factors, heat styling, chemicals, and even aging can
        deplete the hair’s natural keratin. This leads to issues like dullness,
        brittleness, and excessive frizz.
      </p>
      <p>
        Keratin hair treatment is a salon-based treatment that restores lost
        keratin to the hair shaft. It involves applying a keratin-infused
        formula to the hair and sealing it in with heat, usually with a flat
        iron. This process smooths the hair cuticle and eliminates frizz,
        leaving your hair looking sleek, shiny, and rejuvenated. While it is
        sometimes referred to as a straightening treatment, it’s more about
        making hair smoother, healthier, and easier to manage.
      </p>
    </div>
  );
};

export default WhyKeratinWhat;
